import { render } from "./MyBenefitList.vue?vue&type=template&id=15e14218"
import script from "./MyBenefitList.vue?vue&type=script&lang=js"
export * from "./MyBenefitList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__